<template>
	<div>
		<select @change="changeClient" v-model="clientId" class="mt-0 form-select max-w-fit text-sm font-semibold">
			<option v-for="client in clients" :key="client.id" :value="client.id" class="pt-2">{{ client.name }}</option>
		</select>

		<notifications classes="notification" position="bottom right"></notifications>
	</div>
</template>

<script>
  export default {
    props: {
    	availableClients: {
    		type: [Array, Object],
    		required: true
    	},

    	selectedClientId: {
    		type: Number,
    		required: true
    	}
    },

	data() {
		return {
			clients: this.availableClients,
			clientId: this.selectedClientId
		}
	},

    methods: {
		changeClient() {
	        axios.post('/api/change-client', {
	            client_id: this.clientId
	        }).then(response => {
                this.$notify({
                    type: 'success',
                    title: 'Client Changed',
                    text: 'Redirecting...'
                });

                setTimeout(() => {
	            		location.href = '/'
                }, 300)

	        }).catch(error => {
	            console.log(error);
	        });
	    }
    },
  }
</script>